import { render } from "./DynamicAppTagListElement.vue.js?vue&type=template&id=05caf732!=!../../../../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DynamicAppTagListElement.vue?vue&type=template&id=05caf732"
import script from "./DynamicAppTagListElement.vue.js?vue&type=script&lang=js!=!../../../../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DynamicAppTagListElement.vue?vue&type=script&lang=js"
export * from "./DynamicAppTagListElement.vue.js?vue&type=script&lang=js!=!../../../../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DynamicAppTagListElement.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-components/render-engine/components/production/elements/dynamic-app-elements/display/DynamicAppTagListElement.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "05caf732"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('05caf732', __exports__)) {
    api.reload('05caf732', __exports__)
  }
  
  module.hot.accept("./DynamicAppTagListElement.vue.js?vue&type=template&id=05caf732!=!../../../../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DynamicAppTagListElement.vue?vue&type=template&id=05caf732", () => {
    api.rerender('05caf732', render)
  })

}


export default __exports__